import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Spinner } from '@w7/ui'
import { claims, consumeKcActionResult, consumeNext, handleOidcCallback, hasConsoleAccess } from '@/auth/oidc'
import { flashToast, toastCopy } from '@/ui/toaster'
import './auth.css'

export function CallbackPage() {
  const navigate = useNavigate()
  const [message] = useState('Signing you in…')

  useEffect(() => {
    let cancelled = false
    void (async () => {
      const callbackUrl = new URL(location.href)
      const aia = consumeKcActionResult(callbackUrl)
      const result = await handleOidcCallback()
      if (cancelled) return
      history.replaceState({}, '', '/callback')

      if (!result.ok) {
        const reason = result.reason === 'missing-code' ? 'denied' : 'error'
        flashToast(reason === 'denied' ? toastCopy.loginDenied : toastCopy.loginError)
        navigate(`/login?reason=${reason}`, { replace: true })
        return
      }

      const who = claims()
      if (!hasConsoleAccess(who)) {
        navigate('/no-access', { replace: true })
        return
      }

      // Application-initiated actions (password / MFA) — toast from real Keycloak status.
      if (aia.action === 'UPDATE_PASSWORD') {
        if (aia.status === 'success') flashToast(toastCopy.passwordChanged)
        else if (aia.status === 'cancelled') flashToast(toastCopy.passwordCancelled)
        else flashToast(toastCopy.passwordChangeIncomplete)
        navigate(consumeNext('/settings/security'), { replace: true })
        return
      }

      if (aia.action) {
        // MFA enroll / delete — destination query (?enrolled= / ?removed=) owns the toast.
        navigate(consumeNext('/settings/security'), { replace: true })
        return
      }

      flashToast(toastCopy.loginSuccess)
      navigate(consumeNext('/'), { replace: true })
    })().catch(() => {
      if (!cancelled) {
        flashToast(toastCopy.loginError)
        navigate('/login?reason=error', { replace: true })
      }
    })
    return () => {
      cancelled = true
    }
  }, [navigate])

  return (
    <div className="w7-auth w7-auth-center" data-testid="auth-callback">
      <Spinner size={22} />
      <p className="w7-dim" style={{ marginTop: 16 }}>
        {message}
      </p>
    </div>
  )
}
